
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("d1G3o"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("3febu"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $cozmU.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $cozmU.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("bjVRl", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $d2a35dc366472da4$var$initialState = {
    portalContainerRef: null,
    autohighlightText: '',
    autohighlightContext: '',
    sessionId: '',
    autohighlightSelectionRect: {
        top: 0,
        left: 0,
        width: 0,
        height: 0
    },
    autohighlightHovered: false,
    showPopup: false,
    popupLoading: false,
    showSpotlight: false,
    existingMap: new Map(),
    lastAcronymReset: ()=>{},
    defineDefinitionOpen: false
};
const $d2a35dc366472da4$export$e324594224ef24da = {
    showAutohighlightPopup: ({ autohighlightText: autohighlightText, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, lastAcronymReset: lastAcronymReset, sessionId: sessionId })=>({ setState: setState })=>{
            setState({
                autohighlightText: autohighlightText,
                autohighlightContext: autohighlightContext,
                autohighlightSelectionRect: autohighlightSelectionRect,
                lastAcronymReset: lastAcronymReset,
                sessionId: sessionId,
                showPopup: true,
                popupLoading: true
            });
        },
    hideAutohighlightPopup: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                showPopup: false,
                popupLoading: false
            });
        },
    setDefineDefinitionOpen: ({ defineDefinitionOpen: defineDefinitionOpen })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                defineDefinitionOpen: defineDefinitionOpen
            });
        },
    setAutohighlightPopupLoaded: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                popupLoading: false
            });
        },
    setAutohighlightHovered: ({ autohighlightHovered: autohighlightHovered })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                autohighlightHovered: autohighlightHovered
            });
        },
    showAutohighlightSpotlight: ({ autohighlightSelectionRect: autohighlightSelectionRect })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                showSpotlight: true,
                autohighlightSelectionRect: autohighlightSelectionRect
            });
        },
    setPortalContainerRef: ({ portalContainerRef: portalContainerRef })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                portalContainerRef: portalContainerRef
            });
        }
};
const $d2a35dc366472da4$export$f24428a461500521 = (0, $8s9DV.createStore)({
    initialState: $d2a35dc366472da4$var$initialState,
    actions: $d2a35dc366472da4$export$e324594224ef24da,
    name: 'readingAidsStore'
});
const $d2a35dc366472da4$export$c6f45fcecbb3630d = (0, $kBr4q.createActionsHook)($d2a35dc366472da4$export$f24428a461500521);
const $d2a35dc366472da4$export$94639db5354ca53c = (0, $kBr4q.createStateHook)($d2a35dc366472da4$export$f24428a461500521);
module.exports["useReadingAidsActions"] = $d2a35dc366472da4$export$c6f45fcecbb3630d;
module.exports["useReadingAidsState"] = $d2a35dc366472da4$export$94639db5354ca53c;

});

parcelRegister("d1G3o", function(module, exports) {

let $97bbfd5f86a5182d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $97bbfd5f86a5182d$var$load("953Uz"),
    $97bbfd5f86a5182d$var$load("fdsim")
]).then(()=>parcelRequire('jgOPc'));

});

parcelRegister("3febu", function(module, exports) {

let $25cdc67fff32cbed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $25cdc67fff32cbed$var$load("kT6dz"),
    $25cdc67fff32cbed$var$load("hfnzR"),
    $25cdc67fff32cbed$var$load("2Ch4R"),
    $25cdc67fff32cbed$var$load("1nuDK"),
    $25cdc67fff32cbed$var$load("icNyU"),
    $25cdc67fff32cbed$var$load("7TnhR"),
    $25cdc67fff32cbed$var$load("hUbK8"),
    $25cdc67fff32cbed$var$load("eSqZD"),
    $25cdc67fff32cbed$var$load("2dg4a"),
    $25cdc67fff32cbed$var$load("9jmMe"),
    $25cdc67fff32cbed$var$load("fcAaN"),
    $25cdc67fff32cbed$var$load("j3345"),
    $25cdc67fff32cbed$var$load("2PFjC"),
    $25cdc67fff32cbed$var$load("iOfkQ"),
    $25cdc67fff32cbed$var$load("6aqkL"),
    $25cdc67fff32cbed$var$load("1Gr4q"),
    $25cdc67fff32cbed$var$load("kkfng"),
    $25cdc67fff32cbed$var$load("8pf8g"),
    $25cdc67fff32cbed$var$load("kccW9"),
    $25cdc67fff32cbed$var$load("j31Fk"),
    $25cdc67fff32cbed$var$load("2J2X1"),
    $25cdc67fff32cbed$var$load("kpuiG"),
    $25cdc67fff32cbed$var$load("eeYoU"),
    $25cdc67fff32cbed$var$load("23idX"),
    $25cdc67fff32cbed$var$load("do0Fh"),
    $25cdc67fff32cbed$var$load("jL43T"),
    $25cdc67fff32cbed$var$load("7oAXW"),
    $25cdc67fff32cbed$var$load("kSgPY"),
    $25cdc67fff32cbed$var$load("dxcsb"),
    $25cdc67fff32cbed$var$load("cyTuQ"),
    $25cdc67fff32cbed$var$load("jqoep"),
    $25cdc67fff32cbed$var$load("6wr18"),
    $25cdc67fff32cbed$var$load("59hV4"),
    $25cdc67fff32cbed$var$load("fWgnv"),
    $25cdc67fff32cbed$var$load("9uywJ"),
    $25cdc67fff32cbed$var$load("9ZFGK"),
    $25cdc67fff32cbed$var$load("fkLbQ"),
    $25cdc67fff32cbed$var$load("bMNgp"),
    $25cdc67fff32cbed$var$load("1T8H1"),
    $25cdc67fff32cbed$var$load("fyKFO"),
    $25cdc67fff32cbed$var$load("d9sg7"),
    $25cdc67fff32cbed$var$load("l0N35"),
    $25cdc67fff32cbed$var$load("4x9Jx"),
    $25cdc67fff32cbed$var$load("96waY"),
    $25cdc67fff32cbed$var$load("52E4q"),
    $25cdc67fff32cbed$var$load("9WGQz"),
    $25cdc67fff32cbed$var$load("a8glC"),
    $25cdc67fff32cbed$var$load("ekuoy"),
    $25cdc67fff32cbed$var$load("1rB5y"),
    $25cdc67fff32cbed$var$load("ffEVr"),
    $25cdc67fff32cbed$var$load("gzrfp"),
    $25cdc67fff32cbed$var$load("br7gN"),
    $25cdc67fff32cbed$var$load("bNJC9"),
    $25cdc67fff32cbed$var$load("4tD9X"),
    $25cdc67fff32cbed$var$load("96tLT"),
    $25cdc67fff32cbed$var$load("Wowvf"),
    $25cdc67fff32cbed$var$load("eRhBr"),
    $25cdc67fff32cbed$var$load("hvMWl"),
    $25cdc67fff32cbed$var$load("hhss7"),
    $25cdc67fff32cbed$var$load("7EorR"),
    $25cdc67fff32cbed$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.7f905a43.js.map
